function getPreviousStart(start) {
  if (
    'previous_start' in start &&
    start.previous_starts != null &&
    start.previous_starts.length > 0
  ) {
    return start.previous_starts.find(prev => prev.scratched_info == null);
  }
  return 'previous_start' in start ? start.previous_start : null;
}

export function parseBridle(start) {
  let changed = null;
  let previousBridle = null;

  const isPreliminary =
    'preliminary_equipment' in start && start.preliminary_equipment != null;
  const dataSource = isPreliminary ? start.preliminary_equipment : start;

  const bridle = dataSource.bridle;
  const isFirstTime = isPreliminary ? Boolean(dataSource.bridle_first) : null;

  const prevStart = getPreviousStart(start);

  if (prevStart != null) {
    const previousDataSource =
      isPreliminary && 'preliminary_equipment' in prevStart
        ? prevStart.preliminary_equipment
        : prevStart;

    if (previousDataSource != null && previousDataSource.bridle != null) {
      previousBridle = previousDataSource.bridle;
      changed =
        bridle != null && previousBridle != null && bridle !== previousBridle;
    }
  }

  return {
    value: bridle,
    previousValue: previousBridle,
    isChanged: changed,
    isFirstTime,
  };
}

export function formatCarriageId(id, format) {
  switch (id) {
    case 10:
      return format === 'short' ? 'VA' : 'Vanlig';
    case 20:
      return format === 'short' ? 'AM' : 'Amerikansk';
    case 30:
      return format === 'short' ? 'HY' : 'Hybrid';
    default:
      return null;
  }
}

const isCarriageEnum = id => id === 10 || id === 20 || id === 30;

export function parseCarriage(start) {
  let changed = null;
  let previousCarriage = null;
  const statistics = null;

  const { carriage_id: carriageId } = start;
  const carriage =
    'carriage' in start ? start.carriage : formatCarriageId(carriageId, 'long');
  const carriageShort = formatCarriageId(carriageId, 'short');
  const isFirstTime =
    'preliminary_equipment' in start
      ? start.preliminary_equipment?.carriage_first
      : (start.carriage_first ?? null);

  if (isCarriageEnum(carriageId)) {
    const prevStart = getPreviousStart(start);

    if (prevStart != null && prevStart.carriage_id != null) {
      previousCarriage = prevStart.carriage;
      changed = carriageId !== prevStart.carriage_id;
    }
  }

  return {
    value: carriage,
    statistics,
    previousValue: previousCarriage,
    isChanged: changed,
    isFirstTime,
    carriageShort,
  };
}

export function isShodFront(shoeId) {
  return shoeId === 'FH' || shoeId === 'F';
}

export function isBareFront(shoeId) {
  return shoeId === 'B' || shoeId === 'H';
}

export function isShodBack(shoeId) {
  return shoeId === 'FH' || shoeId === 'H';
}

export function isBareBack(shoeId) {
  return shoeId === 'B' || shoeId === 'F';
}

export function formatShoeId(id) {
  switch (id) {
    case 'U':
      return 'Okänd';
    case 'B':
      return 'Barfota runt om';
    case 'F':
      return 'Barfota bak';
    case 'H':
      return 'Barfota fram';
    case 'FH':
      return 'Skor runt om';
    default:
      return null;
  }
}

export function parseShoes(start) {
  let changed = null;
  let frontChanged = null;
  let backChanged = null;
  let previousShoes = null;

  const { shoes, shoe_id: shoeId } = start;
  const front = isShodFront(shoeId) ? true : isBareFront(shoeId) ? false : null;
  const back = isShodBack(shoeId) ? true : isBareBack(shoeId) ? false : null;
  const isFirstTime =
    'preliminary_equipment' in start
      ? start.preliminary_equipment?.shoes_first
      : (start.shoes_first ?? null);

  if (formatShoeId(shoeId) != null) {
    const prevStart = getPreviousStart(start);

    if (
      prevStart != null &&
      prevStart.shoe_id != null &&
      prevStart.shoe_id !== 'U'
    ) {
      previousShoes = prevStart.shoes;
      const prevShoeId = prevStart.shoe_id;
      if (shoeId === prevShoeId) {
        frontChanged = false;
        backChanged = false;
        changed = false;
      } else {
        changed = true;

        const prevFront = prevShoeId === 'FH' || prevShoeId === 'F';
        const prevBack = prevShoeId === 'FH' || prevShoeId === 'H';
        frontChanged = front !== prevFront;
        backChanged = back !== prevBack;
      }
    }
  }

  return {
    value: shoes,
    previousValue: previousShoes,
    isChanged: changed,
    isFirstTime,
    front,
    back,
    frontChanged,
    backChanged,
  };
}
